import React from 'react';
import {classes, style} from './doppe-page-action-media-view.st.css';
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";
import {
    enumValueOrDefault,
    evaluateFunction,
    HtmlObjectResizeMode,
    OmitStrict,
    PickKeys
} from "@wix/devzai-utils-common";
import {
    BymoPageActionMediaLayout,
    BymoPageActionMediaSize,
    BymoPageActionMediaSizing,
    BymoPageActionMediaViewSettings,
    BymoPageMedia,
    bymoPageMediaIsBymoPageWixVideoResource, bymoPageMediaIsEmbeddedVideoPlayer
} from "../../client-server-common";
import {
    DoppeViewerVideoPlayer
} from "../doppe-viewer-video-player/doppe-viewer-video-player";
import {EmbeddedVideoPlayer} from "@wix/devzai-utils-react";

export const DoppePageActionMediaView = React.memo(function DoppePageActionMediaView (props: DoppePageActionMediaView.Props) {
    const {
        mediaViewSettings,
        mediaResource,

        className,
        ...restProps
    } = props;

    const layoutSpecificProps = evaluateFunction(() => {

        return {
            layoutSpec: evaluateFunction(() => {

                if (mediaViewSettings.mediaSizing === BymoPageActionMediaSizing.ShowFullImage) {
                    return {autoHeight: true};
                }

                if (mediaViewSettings.mediaSizing === BymoPageActionMediaSizing.ShowFullImageWithHeightLimit) {
                    return {autoHeight: true, maxHeight: 360}
                }

                const mediaSize = enumValueOrDefault(BymoPageActionMediaSize, mediaViewSettings.size, BymoPageActionMediaSize.Ratio16By9);

                switch (mediaSize) {
                    case BymoPageActionMediaSize.Ratio21By9: {
                        return {widthHeightRatio: 21 / 9};
                    }
                    case BymoPageActionMediaSize.Ratio16By9: {
                        return {widthHeightRatio: 16 / 9};
                    }
                    case BymoPageActionMediaSize.Ratio3By2: {
                        return {widthHeightRatio: 3 / 2};
                    }
                    case BymoPageActionMediaSize.Square: {
                        return {widthHeightRatio: 1};
                    }
                }
            }),
            mediaVerticalPosition: mediaViewSettings.alignment.vertical,
            mediaHorizontalPosition: mediaViewSettings.alignment.horizontal,
            mediaResizeMode: evaluateFunction(() => {
                switch (mediaViewSettings.mediaLayout) {
                    case BymoPageActionMediaLayout.Cropped: {
                        return HtmlObjectResizeMode.Cover;
                    }
                    case BymoPageActionMediaLayout.Contain: {
                        return HtmlObjectResizeMode.Contain;
                    }
                }
            })
        }
    }) satisfies Pick<DoppePageMediaView.Props, DoppePageActionMediaView.OmittedProps>


    if (mediaResource && bymoPageMediaIsBymoPageWixVideoResource(mediaResource) && mediaResource.renderAsPlayer) {
        return (
            <DoppeViewerVideoPlayer
                className={style(classes.root, className)}
                videoResource={mediaResource}
                muteVideo={false}
                autoplay={mediaResource.playerAutoPlay ?? false}
            />
        )
    }

    if (mediaResource && bymoPageMediaIsEmbeddedVideoPlayer(mediaResource)) {
        return (
            <EmbeddedVideoPlayer
                className={style(classes.root, className)}
                autoplay={mediaResource.playerAutoPlay ?? false}
                videoUrl={mediaResource.externalVideoUrl}
                muteVideo={false}
                widthHeightRatio={16/9}
            />
        )
    }

    return (
        <DoppePageMediaView
            {...restProps}
            className={style(classes.root, className)}
            mediaResource={mediaResource}
            {...layoutSpecificProps}
        />
    );
});

export namespace DoppePageActionMediaView {

    export type OmittedProps = PickKeys<DoppePageMediaView.Props, 'layoutSpec' | 'mediaResizeMode' | 'mediaVerticalPosition' | 'mediaHorizontalPosition'>

    export interface Props extends OmitStrict<DoppePageMediaView.Props, OmittedProps | 'mediaResource'> {
        mediaViewSettings: BymoPageActionMediaViewSettings;
        mediaResource: BymoPageMedia | null;
    }
}
